module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "text-center logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.stylePathToLogo || '/static/img/logo/logo.png'
    }
  }), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "w5-error-page"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('h1', [_vm._v(_vm._s(_vm._f("ftc")('error/under_construction_title')))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('Clock')], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('error/under_construction')),
      expression: "localeFtc('error/under_construction')"
    }]
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-096e9d08"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/crud/error503.vue
// module id = 730
// module chunks = 0